// web/src/content/disclosures.ts
// Single source of truth for fiduciary / educational disclosure copy.
// PLACEHOLDER LANGUAGE — REQUIRES LEGAL REVIEW BEFORE PUBLIC LAUNCH.
//
// Used by:
//   - Footer on every page
//   - Both signup pages (real + education)
//   - Every analysis output rendering
//   - Luna response footer (when configured)
export const DISCLOSURE_SHORT = "Matchrail provides educational analysis, not personalized investment advice.";
export const DISCLOSURE_MEDIUM = "Matchrail provides educational analysis and calculations based on the data you provide. " +
    "It does not constitute personalized investment, tax, or legal advice. " +
    "Consult a licensed professional before acting on any output.";
export const DISCLOSURE_FULL = `Matchrail Disclosures

Educational tool, not a registered investment adviser
Matchrail is an educational analysis platform. It is not a registered
investment adviser under the Investment Advisers Act of 1940 or any
state-equivalent statute. The analyses and calculations Matchrail produces
are educational in nature and based solely on the inputs you provide.

No personalized investment, tax, or legal advice
Nothing Matchrail outputs constitutes personalized investment, tax, or
legal advice. Tax computations rely on your inputs and reference data;
they are not a substitute for a CPA's review. Investment computations are
projections based on stated assumptions, not predictions of actual returns.

Demo accounts
Demo accounts use illustrative profiles with hypothetical numbers. Every
dollar figure in a demo session is fictional and should never be used as
the basis for a real financial decision.

Consult licensed professionals
Before acting on any Matchrail output, consult a licensed financial
adviser, tax professional, or attorney as appropriate for your situation.

No fiduciary relationship
Use of Matchrail does not create a fiduciary, advisory, or attorney-client
relationship between you and Matchrail or its operators.`;
